/* Dot and swipe state for the server-rendered mobile gallery. */
(function () {
  function bind(peek) {
    if (peek.getAttribute("data-hfb-gallery") === "ready") return;
    peek.setAttribute("data-hfb-gallery", "ready");

    var track = peek.querySelector(".hfb-070-peek__track");
    var dots = peek.querySelectorAll(".hfb-070-peek__dot");
    if (!track || !dots.length) return;

    function setActive(index) {
      for (var d = 0; d < dots.length; d++) {
        var on = d === index;
        dots[d].classList.toggle("is-active", on);
        dots[d].setAttribute("aria-selected", on ? "true" : "false");
      }
    }

    function step() {
      var slide = track.children[0];
      if (!slide) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function indexFromScroll() {
      var width = step();
      if (!track.children.length || !width) return 0;
      var index = Math.round(track.scrollLeft / width);
      if (index < 0) index = 0;
      if (index > dots.length - 1) index = dots.length - 1;
      return index;
    }

    var frame = 0;
    track.addEventListener("scroll", function () {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        setActive(indexFromScroll());
      });
    }, { passive: true });

    peek.addEventListener("click", function (event) {
      var button = event.target.closest(".hfb-070-peek__dot");
      if (!button || !peek.contains(button)) return;
      var index = parseInt(button.getAttribute("data-index"), 10) || 0;
      if (!track.children[index]) return;
      track.scrollTo({ left: index * step(), behavior: "smooth" });
      setActive(index);
    });
  }

  function init() {
    var galleries = document.querySelectorAll(".hfb-070-peek");
    for (var i = 0; i < galleries.length; i++) bind(galleries[i]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
